import { IDrillingCost } from '../../interfaces/idrilling-cost';
import { BuildSheetActivity } from '../build-sheet-activity';
import { GenSubSub } from '../gen-sub-sub';
import { UnitOfMeasure } from '../unit-of-measure';

export class DrillingCostBase {
  DrillingCostId: number;
  BuildSheetActivityId: number;
  UnitCost: number | null;
  UnitOfMeasureId: number | null;
  LumpSum: number | null;
  GenSubSubId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  BuildSheetActivity?: BuildSheetActivity;
  GenSubSub?: GenSubSub;
  UnitOfMeasure?: UnitOfMeasure;

  constructor(item?: IDrillingCost) {
    if (item) {

      this.DrillingCostId = item.DrillingCostId;
      this.BuildSheetActivityId = item.BuildSheetActivityId;
      this.UnitCost = item.UnitCost;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.LumpSum = item.LumpSum;
      this.GenSubSubId = item.GenSubSubId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.BuildSheetActivity = new BuildSheetActivity(item.BuildSheetActivity);
      this.GenSubSub = new GenSubSub(item.GenSubSub);
      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
    }
  }
}